import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=149e6fcc&scoped=true&"
import script from "./TabCard.vue?vue&type=script&lang=js&"
export * from "./TabCard.vue?vue&type=script&lang=js&"
import style0 from "./TabCard.vue?vue&type=style&index=0&id=149e6fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149e6fcc",
  null
  
)

export default component.exports